export type PodcastSpeakerRole =
  | "Teacher"
  | "Student"
  | "Native Speaker 1"
  | "Native Speaker 2"
  | "Speaker 1"
  | "Speaker 2";

export interface TranscriptSegment {
  id: string;
  startTime: number;
  endTime: number;
  text: string;
  translation?: string;
  audioUrl?: string;
  speaker?: string;
  isExplained?: boolean;
  isSpeaking?: boolean;
  isHighlighted?: boolean;
}

export type PodcastStatus = "draft" | "scripted" | "audio_ready";
export type PodcastVisibility = "public" | "private";
export type PodcastSource = "ai_generated" | "manual" | "chapter";
export type PodcastCefrLevel = "A1" | "A2" | "B1" | "B2" | "C1" | "C2";
export type PodcastDialogueLength = "short" | "long";

export interface PodcastTranscriptSegment {
  id: string;
  speaker: PodcastSpeakerRole;
  text: string;
  originalText?: string;
  ssmlText?: string;
  isEdited: boolean;
  audioUrl?: string;
  audioDuration?: number;
  language?: string;
  voiceName?: string;
  personaId?: string;
  personaName?: string;
  personaGender?: "female" | "male";
  ttsProvider?: string;
  ttsVoice?: string;
  ttsLanguage?: string;
}

export interface PodcastProject {
  id: string;
  userId?: string;
  title: string;
  topic: string;
  targetLanguage: string;
  targetLanguageCode?: string;
  cefrLevel: PodcastCefrLevel;
  source: PodcastSource;
  status: PodcastStatus;
  visibility: PodcastVisibility;
  segments: PodcastTranscriptSegment[];
  chapterId?: string | null;
  chapterLanguageCode?: string | null;
  consistencyReport?: string | null;
  createdAt: number;
  updatedAt?: number;
}

export interface ManualPodcastSegment {
  id: string;
  speaker: "Speaker 1" | "Speaker 2";
  originalText: string;
  convertedText: string;
  isEdited: boolean;
  audioUrl?: string;
  audioDuration?: number;
}

export const PODCAST_VOICE_BY_SPEAKER: Record<PodcastSpeakerRole, string> = {
  Teacher: "Charon",
  Student: "Leda",
  "Native Speaker 1": "Fenrir",
  "Native Speaker 2": "Kore",
  "Speaker 1": "Fenrir",
  "Speaker 2": "Kore",
};

export function normalizePodcastSpeakerRole(value: string): PodcastSpeakerRole {
  const speaker = value.toLowerCase();
  if (speaker.includes("teacher") || speaker.includes("professor") || speaker.includes("host")) {
    return "Teacher";
  }
  if (speaker.includes("student") || speaker.includes("learner")) {
    return "Student";
  }
  if (
    speaker.includes("native") &&
    (speaker.includes("2") ||
      speaker.includes("second") ||
      speaker.includes("two") ||
      speaker.includes("other") ||
      speaker.includes("kore"))
  ) {
    return "Native Speaker 2";
  }
  if (speaker.includes("native")) {
    return "Native Speaker 1";
  }
  if (speaker.includes("speaker 2")) {
    return "Speaker 2";
  }
  if (speaker.includes("speaker 1")) {
    return "Speaker 1";
  }
  return "Native Speaker 1";
}
